import Lottie from "lottie-react";
import animationData from "./lotties/closed.json";

const ClosedSpinner = (props) => {
  return (
    <div className="lottie-wrapper">
      <Lottie
        animationData={animationData}
        style={{ height: props.height, width: props.width, objectFit: "cover" }}
      />
    </div>
  );
};

export default ClosedSpinner;
